<template>
  <div>
    <div>
      <span class="xbed-sub-title">关键字/激活码管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>关键字/激活码管理</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='名称:' prop='name' :label-width='50'>
        <Input type='text' v-model.trim="queryKeyWords.name" style="width:200px;"></Input>
      </FormItem>
      <FormItem label='关键字/激活码:' prop='keys' :label-width='120'>
        <Input type='text' v-model.trim="queryKeyWords.keys" style="width:220px;"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="changeQueryKeyWord">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="newPayment('add')">新增关键字/激活码</Button>
      </FormItem>
      <Content>
        <Table stripe :columns="columnsList" :data='dataList' :loading='cardListLoading'></Table>
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer :page-size="queryKeyWords.size" :current="queryKeyWords.page" :total="listTotal" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </Content>
    </Form>
    <!-- 弹窗 -->
    <Modal v-model="modalInfo.display" :title="modalInfo.title" ref="modalInfoModal" :loading="true" @on-ok="modalInfoOK">
      <Form @submit.native.prevent="preventSubmit" inline :rules='modalInfoRules' ref="modalInfoForm">
        <FormItem v-if="modalInfo.id" label="物品id：" prop="id" :label-width='90'>
          <Input :value="modalInfo.id" disabled></Input>
        </FormItem>
        <FormItem label='名称' prop='name' :label-width='90'>
          <Input type='text' v-model="modalInfo.name" :maxlength="200" style="width:300px;"></Input>
        </FormItem>
        <FormItem label='关键字/激活码(多个请用，号隔开)' prop='keyWords' :label-width='90'>
          <Input type='textarea' v-model="modalInfo.keyWords" style="width:300px;" :maxlength="2000" :autosize="{minRows: 2,maxRows: 2}"></Input>
        </FormItem>
        <FormItem label='备注' prop='remark' :label-width='90'>
          <Input type='text' v-model="modalInfo.remark" :maxlength="2000" style="width:300px;"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
// import Moment from "moment";
export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
  data () {
    const validateGoodsList = {
      name:(rule,value,callback) =>{
        if(!this.modalInfo.name){
          callback(new Error('名称不能为空'))
        }else{
          callback()
        }
      },
      keyWords:(rule,value,callback) =>{
        if (!this.modalInfo.keyWords) {
          callback(new Error('关键字/激活码不能为空'))
        }else{
          callback()
        }
      },
      remark:(rule,value,callback) =>{
        if (!this.modalInfo.remark) {
          callback(new Error('备注不能为空'))
        }else{
          callback()
        }
      }
    }
    return {
      queryKeyWords:{
        url:'/api/activationConfig',
        name:'',
        keys:'',
        size:10,
        page:1,
      },
      cardListLoading:false,
      dataList:[],
      listTotal:0,
      columnsList:[
        {
          title:'ID',
          key:'activationId',
          align:'center',
          width:100
        },
        {
          title:'名称',
          key:'name',
          align:'center'
        },
        {
          title:'关键字/激活码',
          key:'keys',
          align:'center'
        },
        {
          title:'备注',
          key:'remark',
          align:'center'
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:150,
          render:(h,params) => {
            return h('div',
            [
              h('Button',{
                props:{
                  type:'info',
                  size:'small'
                },
                style:{
                  margin:'3px',
                  display: params.row.type === 2 ? 'inline-block' :'none'
                },
                on:{
                  click:()=>{
                    this.newPayment('edit',params.row)
                  }
                }
              },'修改'),
              h('Button',{
                props:{
                  type:'error',
                  size:'small'
                },
                style:{
                  margin:'3px',
                  display: params.row.type === 2 ? 'inline-block' :'none'
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'activation_del' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    this.$Modal.confirm({
                      title:'消息提醒',
                      content: `确定删除<span style='color:red;font-size:14px;'>${params.row.name}</span>吗？ \n 一经确定，无法修改！`,
                      okText:'确定',
                      cancelText:'取消', 
                      onOk:()=>{
                        this.deleteBtn(params.row.activationId)
                      }
                    })
                  }
                }
              },'删除'),
               h('Button',{
                props:{
                  type:'primary',
                  size:'small',
                  disabled: params.row.type != '2' ? true :false
                },
                style:{
                  margin:'3px',
                  display: params.row.type != '2' ? 'inline-block' :'none'
                }
              },'不可操作')
            ])
          }
        },
      ],
      modalInfo:{
        display:false,
        title:'',
        name:'',
        keyWords:'',
        remark:''
      },
      modalInfoRules:{
        name:[
          {required:true,validator:validateGoodsList.name,trigger:'blur'}
        ],
        keyWords:[
          {requires:true,validator:validateGoodsList.keyWords,trigger:'blur'}
        ],
        remark:[
          {required:true,validator:validateGoodsList.remark,trigger:'blur'}
        ]
      }
    }
  },
  mounted() {
    this.$Notice.config( {
			top: 200
		} );
    this.queryList()
  },
  methods: {
    async queryList(){
      if ( !Utils.hasPermission( 'activation_list' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
      }
      let params = {
        url:this.queryKeyWords.url,
        name:this.queryKeyWords.name,
        keys:this.queryKeyWords.keys,
        size:this.queryKeyWords.size,
        page:this.queryKeyWords.page - 1,
      }
      this.cardListLoading = true
      let resp = (await API.omsAPI[this.env].marketing.actityManage('GET',params,this.token)).data
      this.cardListLoading = false
      if ( resp.retCode ) {
				this.$Notice.error({
					title: '活动管理数据异常',
					desc: resp.msg
				})
				return
      }
      this.dataList = resp.content
      this.listTotal = resp.total
    },
    changeQueryKeyWord(){
      this.queryKeyWords.page = 1
      this.queryList()
    },
    changePageSize(pageSize){
      this.queryKeyWords.page = 1
      this.queryKeyWords.size = pageSize
      this.queryList()
    },
    changePage(page){
      this.queryKeyWords.page = page
      this.queryList()
    },
    initModal(){
      this.modalInfo.name = ''
      this.modalInfo.keyWords = ''
      this.modalInfo.remark = ''
      this.modalInfo.id = ''
    },
    // 新增关键字/激活码
    newPayment(type,params){
      if ( !Utils.hasPermission( 'activation_edit' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      this.initModal()
      if (type === 'add') {
        this.modalInfo.title = '新增关键字/激活码'
      }else if(type === 'edit'){
        this.modalInfo.title = '修改关键字/激活码'
        this.modalInfo = Object.assign({}, this.modalInfo, {
          id:params.activationId,
          name: params.name,
          keyWords:params.keys,
          remark:params.remark
        });
      }
      this.modalInfo.display = true
    },
    // 弹窗
    async modalInfoOK(){
     let validResult = false;
     this.$refs.modalInfoForm.validate(valid =>{
       validResult = valid
     })
     if (!validResult) {
       this.$refs.modalInfoModal.buttonLoading = false
       return
     }
     let Addparams = {
        url:'/api/activationConfig',
        name:this.modalInfo.name,
        remark:this.modalInfo.remark,
        keys:this.modalInfo.keyWords
      }
     let Editparams = {
        url:'/api/activationConfig',
        name:this.modalInfo.name,
        remark:this.modalInfo.remark,
        keys:this.modalInfo.keyWords,
        activationId:this.modalInfo.id
      }
      const type = this.modalInfo.id ? 'PUT':'POST'
      const params = this.modalInfo.id ? Editparams:Addparams
      let resp = (await API.omsAPI[this.env].marketing.actityManage(type,params,this.token)).data
      if (resp.retCode){
				this.$Notice.error( {
					title: "新增关键字/激活码失败",
					desc: resp.msg
				} );
				this.$refs.modalInfoModal.buttonLoading = false;
				return
			}
			this.$Notice.success( {
				title: "关键字/激活码操作成功",
				desc: resp.msg
			});
      this.$refs.modalInfoModal.buttonLoading = true;
      this.modalInfo.display = false
      this.queryList()
    },
    // 删除
    async deleteBtn(id){
      let params = {
        url:'/api/activationConfig',
        activationId:id
      }
     let resp = (await API.omsAPI[this.env].marketing.actityManage('DELETE',params,this.token)).data
      if (resp.retCode){
				this.$Notice.error( {
					title: "删除关键字/激活码失败",
					desc: resp.msg
				} );
				return
			}
			this.$Notice.success( {
				title: "删除关键字/激活码操作成功",
				desc: resp.msg
      });
      this.queryList()
    }
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/marketing/activationList.vue